module.exports = __webpack_public_path__ + "img/logo.14bc65bd.svg";